import { render, staticRenderFns } from "./impayes.vue?vue&type=template&id=eedaa80c&scoped=true&"
import script from "./impayes.vue?vue&type=script&lang=js&"
export * from "./impayes.vue?vue&type=script&lang=js&"
import style0 from "./impayes.vue?vue&type=style&index=0&id=eedaa80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedaa80c",
  null
  
)

export default component.exports